import React from 'react';
import '../styles/Maintenance.css';

function Maintenance() {
  return (
    <div className="maintenance-page">
      <div className="maintenance-card">
        <h1>Chitrakala Arts</h1>
        <p>Chitrakala Arts is temporarily under maintenance. Please check back soon.</p>
      </div>
    </div>
  );
}

export default Maintenance;
